import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {ContactIcon} from 'shells/icon';
import {SyncRegularIcon} from 'shells/icon/svg/sync-regular-icon';
import {TwoLine} from 'shells/two-line/two-line';

import {SalesAutomationCard} from './sales-automation-card';

type Props = {
    parentId: string;
    isHidden: boolean;
    isAssigneeEnabled: boolean;
    defaultAssigneeName: string | null | undefined;
    shouldRoundRobin: boolean | null | undefined;
    specialCaseCount: number;
};

export class SalesAutomationCardUserAssignment extends React.PureComponent<Props> {
    render() {
        const specialCaseText =
            this.props.specialCaseCount === 1
                ? '1 Special case'
                : `${this.props.specialCaseCount} Special cases`;

        let assigneeText;
        if (this.props.defaultAssigneeName) {
            if (this.props.specialCaseCount) {
                assigneeText = `${this.props.defaultAssigneeName} with ${specialCaseText}`;
            } else {
                assigneeText = this.props.defaultAssigneeName;
            }
        } else if (this.props.specialCaseCount) {
            assigneeText = specialCaseText;
        }

        return (
            <SalesAutomationCard
                parentId={this.props.parentId}
                isHidden={this.props.isHidden}
                borderColor={colors.orange}
                type='userAssignments'
                entityId='fakeId'
            >
                <TwoLine
                    icon={this.props.shouldRoundRobin ? SyncRegularIcon : ContactIcon}
                    iconSize={24}
                    topRow={
                        this.props.shouldRoundRobin ? 'Round-robin leads to' : 'Assign leads to'
                    }
                    bottomRow={this.props.isAssigneeEnabled ? assigneeText : undefined}
                    isLargeWithSmallBottomRow={true}
                />
            </SalesAutomationCard>
        );
    }
}
